/**
 * Main content column for logged-in provider portal pages. Keeps Patient Orders,
 * Contact Us, and Place new order (OrderForm) left-aligned and the same width.
 */
export const PROVIDER_PORTAL_MAIN_COLUMN_CLASS =
  "tw-border-box tw-mx-auto tw-w-10/12 tw-border-0 tw-px-[16px] 1440:tw-w-[96%]";
